import React from 'react'
import Img1 from '../images/image.png'
import '../css/services.css'

export default function InnerIMG() {
  return (
    <>
      <div className="container main-Img-container">
            <div className="row row-cols-3 Main-Img-Row">
                <div className="col Image-col-inner">
                    <div className="Img-main">
                        <img src={Img1} alt="" />
                    </div>
                </div>
                <div className="col Image-col-inner">
                    <div className="Img-main">
                        <img src={Img1} alt="" />
                    </div>
                </div>
                <div className="col Image-col-inner">
                    <div className="Img-main">
                        <img src={Img1} alt="" />
                    </div>
                </div>
                <div className="col Image-col-inner">
                    <div className="Img-main">
                        <img src={Img1} alt="" />
                    </div>
                </div>
                <div className="col Image-col-inner">
                    <div className="Img-main">
                        <img src={Img1} alt="" />
                    </div>
                </div>
            </div>
      </div>
    </>
  )
}
